import { INVALIDATE_COMPTE_PAIEMENT } from 'actions/invalidationTags';
import { ApiMananger } from "actions/rtkquery";
import { GET_COMPTE_PAIEMENT_API_ROUTE } from "routes/api/endpoints";

const comptePaiementApi = ApiMananger.injectEndpoints({
    endpoints: (build) => ({

    getComptePaiement: build.query({
        query: ({ dossier_id }) => `${GET_COMPTE_PAIEMENT_API_ROUTE}?dossier_id=${dossier_id}`,
        providesTags: [INVALIDATE_COMPTE_PAIEMENT],
    }),
    getComptePaiementId: build.query({
        query: ({ dossier_id, id }) => `${GET_COMPTE_PAIEMENT_API_ROUTE}?dossier_id=${dossier_id}&id=${id}`,
        providesTags: [INVALIDATE_COMPTE_PAIEMENT],
    }),
}),
});

export const {
useGetComptePaiementIdQuery,
useGetComptePaiementQuery
} = comptePaiementApi;
